// extracted by css-extract-rspack-plugin
module.exports =  {"morebtn":"YfaRN","lighBgBtn":"djbrd","blackBg":"joZJu","text_white":"wOrQq","downmorebtn":"kpx0P","isNoLink":"hfSfx"};